// @flow
type DialogI = {
  [string]: string,
};

export const dialogs: DialogI = {
  CONNECT_TO_STRIPE: "connectToStripe",
  SESSION_TIMEOUT: "sessionTimeout",
};
